import userApi from './userApi';

const isDesktopApp = window.ipcRenderer;
const ipcRenderer = window.ipcRenderer;

export default {
  init: (store) => {
    if (isDesktopApp) {
      ipcRenderer.on('signInUrl', (event, link) => {
        console.log(link);
        const webLink = link.replace('at-and://', 'https://at-and.com/');
        let email = window.localStorage.getItem('emailForSignIn');
        if (!email) {
          email = window.prompt('Please provide your email for confirmation');
        }

        const params = new URLSearchParams(webLink);

        userApi.signInWithLink(store, email, webLink, params);
      });

      ipcRenderer.on('currentSlide', (event, currentSlide) => {
        console.log('Presentation API:', currentSlide);
        store.dispatch('setCurrentSlide', currentSlide);
      });

      ipcRenderer.on('presentationEnded', () => {
        console.log('Presentation ended');
        store.dispatch('endCurrentPresentedPresentation');
        store.dispatch('stopBroadcasting');
      });
    }
  },

  listenToPresentationStatus: (numberOfSlides) => {
    if (isDesktopApp) {
      ipcRenderer.send('presentation-standby', { numberOfSlides });
    }
  },

  stopListenToPresentationStatus: () => {
    if (isDesktopApp) {
      ipcRenderer.send('presentation-stop');
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/desktopAppApi.js